<script setup>
import { computed } from 'vue';
import { asset } from '../helpers.js';

const imgTrikot = asset('/hkcm/images/trikot.png', 'public');

const props = defineProps({
    totalEndPriceGross: { type: Number, required: true },
    differencePrice: { type: Number, required: true },
    minOrderValue: { type: Number, required: true }
});

const isEligible = computed(() => props.totalEndPriceGross >= props.minOrderValue);

const progress = computed(() =>
    Math.min(100, Math.round((props.totalEndPriceGross / props.minOrderValue) * 100))
);

const toCurrency = (v) =>
    typeof window !== 'undefined' && window?.Intl
        ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(v)
        : `${v.toFixed(2)} €`;
</script>

<template>
    <!-- Cart Banner (Gewinnspiel) -->
    <section class="w-full rounded-2xl p-3 my-4 bg-[#EFF6FF] border border-[rgba(0,108,255,0.2)]" role="status" aria-live="polite">
        <div class="flex items-center gap-3 mb-0">
            <img :src="imgTrikot" alt="Trikot" class="h-14 w-14 shrink-0 object-contain" />
            <h3 class="font-bold text-base leading-tight text-[#006CFF]">
                <span v-if="isEligible">Teilnahme gesichert!</span>
                <span v-else>Noch {{ toCurrency(differencePrice) }} bis zur Teilnahme!</span>
            </h3>
        </div>

        <p class="text-sm text-gray-700 mb-3">
            Gewinnspielteilnahme ab <strong>{{ toCurrency(minOrderValue) }}</strong>
        </p>

        <!-- Progress -->
        <div class="mb-3">
            <div class="flex justify-between text-xs text-gray-600 mb-1.5">
                <span>Fortschritt</span>
                <span>{{ progress }}%</span>
            </div>
            <div class="h-[10px] w-full rounded-full overflow-hidden bg-[rgba(0,108,255,0.1)]">
                <div
                    class="h-full rounded-full transition-all duration-300 bg-[#006CFF]"
                    :style="{ width: progress + '%' }"
                ></div>
            </div>
        </div>
    </section>
</template>
